module.exports = "/img/LOGO-application.ef0d9f35.png";